import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'

@Component
export default class SlisdeDown extends Vue {
  @Prop({ default: false }) open!: Boolean
  @Prop({ default: 'left' }) position!: String

  @Emit()
  onClose () {
  }

}
